import logger from "@/services/Logger";

import {
  CLEAR_QUEUE,
  ADD_TO_QUEUE,
  REMOVE_FROM_QUEUE,
  SET_CURRENT_TRACK_ID,
  SET_QUEUE_INDEX,
  SET_QUEUE_POSITION
} from "@/store/mutation-types";

export default {
  [CLEAR_QUEUE](state) {
    state.tracklist = [];
    logger.log("QUEUE", "CLEARED");
  },
  [ADD_TO_QUEUE](state, tracks) {
    state.tracklist = [...state.tracklist, ...tracks];
    logger.log("QUEUE", "TRACKS ADDED", tracks);
  },
  [REMOVE_FROM_QUEUE](state, track) {
    state.tracklist = state.tracklist.filter(_track => _track !== track);
    logger.log("QUEUE", "TRACK REMOVED", track);
  },
  [SET_CURRENT_TRACK_ID](state, id) {
    state.currentTrackId = id;
  },
  [SET_QUEUE_INDEX](state, index) {
    state.currentIndex = index;
  },
  [SET_QUEUE_POSITION](state, position) {
    state.position = position;
  }
};
